import React, { useCallback } from "react";
import { AcceptBeingBeviStyled } from "./styled/beingBeviStyled";
import { Modal } from "antd";
import { t } from "../intlSingleton";

type Props = {
  open: boolean;
  loading: boolean;
  onCancel: () => void;
  acceptBeingBevi: () => void;
}

export const AcceptBeingBevi = ({ open, loading, onCancel, acceptBeingBevi }: Props) => {
  const confirm = useCallback(() => {
    acceptBeingBevi();
  }, [acceptBeingBevi])

  return <Modal
    width={600} zIndex={10001} confirmLoading={loading} onOk={confirm} onCancel={onCancel} cancelText={t('app.btn_cancel')} okText={t('app.btn_confirm')}
    centered open={open} title={false}>
      <p style={{ fontSize: 14}} dangerouslySetInnerHTML={{ __html: t('app.report.acceptBeingBevi') }} />
  </Modal>
}
